import Splide from "@splidejs/splide";

const slider = document.querySelector(".full-width-slider .splide");
if (slider) {
    new Splide(slider, {
        type: 'loop',
        rewind: false,
        arrows: false,
        autoplay: true,
        interval: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        lazyLoad: false,
        pagination: true,
        perPage: 2,
        gap: '30px',
        padding: { left: '0', right: '5%' },
        dragMinThreshold: { mouse: 20, touch: 35 },

        breakpoints: {
            1200: {
                perPage: 1,
                gap: '16px',
                padding: { left: '0', right: '10%' },
            },
        },
    }).mount();
}